import { useAtom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'

import { AppBreakpoint } from '@makyoapp/makyo-sdk/models/AppBuilder'

import { STORAGE_KEYS } from '@/shared/constants'

const deviceAtom = atomWithStorage<AppBreakpoint>(STORAGE_KEYS.BUILDER_ACTIVE_VIEWPORT, 'phone')

export const useActiveDevice = () => useAtom(deviceAtom)
